<template>
  <SideModal
    :show="team && show"
    @update:show="
      {
        if (!state.loadingSave) $emit('update:show', $event);
      }
    "
    location="left"
    close-on-overlay-click
  >
    <div class="modal-container">
      <div class="modal-top">
        <span class="d-flex gap-3 align-center">
          <Typography color="primary" weight="600" size="1.25rem">Edit Team</Typography>
          <v-icon size="x-small" @click="copyToClipboard(team.uid)">mdi-content-copy</v-icon>
        </span>

        <v-btn
          @click="
            {
              if (!state.loadingSave) $emit('update:show', false);
            }
          "
          variant="plain"
          color="normal"
          icon
          ><v-icon color="gray600">mdi-close</v-icon></v-btn
        >
      </div>

      <form @submit.prevent="save" class="modal-body">
        <div>
          <v-text-field
            :disabled="team.deleted"
            class="custom-input"
            color="primary"
            label="Team Name"
            v-model="state.team_name"
          ></v-text-field>
          <FormValidate
            :validate="state.team_name"
            :regex="/.{1,50}/"
            title="Team name must have length of 1-50"
          ></FormValidate>
        </div>
        <div>
          <div style="display: flex; width: 100%; gap: 15px; justify-content: stretch">
            <v-btn
              v-if="!team.deleted"
              @click="setDelete(true)"
              :loading="state.loadingDelete"
              style="text-transform: capitalize; flex-grow: 1"
              color="#E5E4DB"
            >
              Delete
            </v-btn>
            <v-btn
              v-if="!team.deleted"
              type="submit"
              :loading="state.loadingSave"
              style="text-transform: capitalize; flex-grow: 1"
              >Save</v-btn
            >
            <v-btn
              v-else
              @click="setDelete(false)"
              :loading="state.loadingDelete"
              style="text-transform: capitalize; flex-grow: 1"
              >Restore</v-btn
            >
          </div>
        </div>
      </form>
    </div>
  </SideModal>
</template>

<script setup lang="ts">
import type { TeamsType } from "@/api_types/school";
import SideModal from "@/components/sideModal.vue";
import Typography from "@/components/typography.vue";
import { watch } from "vue";
import { reactive } from "vue";
import { useAlertsStore } from "@/stores/alerts";
import useTeams from "@/stores/school/teams";
import FormValidate from "@/components/formValidate.vue";
import { copyToClipboard } from "@/utils";

const props = defineProps<{
  team: TeamsType[number];
  show: boolean;
}>();

const state = reactive({
  loadingSave: false,
  loadingDelete: false,
  team_name: ""
});

const teamsS = useTeams();

watch([() => props.team, () => props.show], () => {
  if (props.team)
    Object.assign(state, {
      team_name: props.team.team_name
    });
});

defineEmits<{
  (e: 'update:show', ...args: any[]): void
}>();

const save = async () => {
  // save Team
  state.loadingSave = true;

  const res = await teamsS.updateTeam(props.team.uid, {
    team_name: state.team_name
  });

  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? "Team Name updated successfully" : "Failed to update team data",
    5
  );
  state.loadingSave = false;
};
const setDelete = async (val: boolean) => {
  // save Team
  state.loadingDelete = true;

  const res = await teamsS.updateTeam(props.team.uid, {
    deleted: val
  });

  const message = val ? "delete" : "restore";
  useAlertsStore().addAlert(
    res ? "success" : "error",
    res ? `Team ${message}d successfully` : `Failed ${message} team data`,
    5
  );
  state.loadingDelete = false;
};
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;

.modal-container {
  padding: 30px;

  .modal-top {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modal-body {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 30px;
  }
}
</style>
